<script>
import { ref } from 'vue'
import mixinComponent from '../../../Mixins/mixinComponent'
import { globalVariablesMixin } from '../../../Mixins/global'
import { useDeliveredAtField } from '../../../../../Composables/DeliveryOrder/useDeliveredAtField.ts'
import ModalConfirmation from '../../UI/Modal/ModalConfirmation.vue'
import BlockContent from '../../UI/Content/BlockContent.vue'
import FormCreator from '../../UI/Form/FormCreator.vue'
import FieldCreator from '../../UI/Form/FieldCreator.vue'
import ButtonAll from '../../UI/Button/ButtonAll.vue'
import ContractDeliveryOrderSignature from './ContractDeliveryOrderSignature.vue'
import SignatureBlock from '../SignatureBlock.vue'
import DeliveryOrderAddressField from './DeliveryOrderAddressField.vue'

export default {
  components: {
    DeliveryOrderAddressField,
    ContractDeliveryOrderSignature,
    ButtonAll,
    FieldCreator,
    FormCreator,
    BlockContent,
    ModalConfirmation,
    SignatureBlock,
  },
  mixins: [mixinComponent, globalVariablesMixin],

  props: {
    contractId: { type: [String, Number], required: true },
    contractNumber: { type: String, required: true },
    deliveryOrderId: { type: Number, default: null },
    uuid: { type: String, required: false },
  },

  data: function () {
    return {
      loading: false,
      sending: false,
      loadField: false,
      params: {},
      def: {},
      formData: null,
    }
  },

  computed: {
    editable() {
      return this.deliveryOrderId && this.deliveryOrder.documentAssoc === null
    },
    cancelable() {
      return (this.deliveryOrder.documentAssoc !== null || this.deliveryOrder.status === 'SIGNED') && !this.uuid
    },
    showDeliveryUpdateButton() {
      return (
        null !== this.deliveryOrder.deliveredAt &&
        null !== this.deliveryOrder.documentAssoc &&
        !this.$refs['formdeliverysingle']?.areAllFieldsDisabled()
      )
    },
    missingDeliveryDate() {
      if (this.deliveryOrder === null) {
        return false
      }

      return (
        null !== this.deliveryOrder.id && false === this.deliveryOrder.esign && null === this.deliveryOrder.deliveredAt
      )
    },
  },

  methods: {
    validateDeliveredAt(deliveredAt) {
      if (!deliveredAt || !this.deliveryOrder.contractSignedAt) {
        return
      }
      const signedAt = this.DateTime.fromISO(this.deliveryOrder.contractSignedAt)

      if (deliveredAt.startOf('day') < signedAt.startOf('day')) {
        this.$refs['modalDeliveredAt'].showModal()
      }
    },
    resetDeliveredAt() {
      this.$refs['formdeliverysingle'].datas['deliveredAt'] = this.deliveryOrder.contractSignedAt
      this.$refs['deliveredAt'].refreshDatepicker()
      this.closeDeliveredAtModal()
    },
    closeDeliveredAtModal() {
      this.$refs['modalDeliveredAt'].closeModal()
    },
    updateData(newData) {
      this.formData = newData
    },
    freeUrl(url) {
      if (!this.uuid) {
        return url
      }

      const separator = url.includes('?') ? '&' : '?'
      return `free/${url}${separator}uniqid=${this.uuid}`
    },
    computeTtc() {
      let amountTtc = 0
      if (Object.keys(this.deliveryOrder).length > 0) {
        let amountReal = this.deliveryOrder.finance.amountReal ? parseFloat(this.deliveryOrder.finance.amountReal) : 0
        let amountServices = this.deliveryOrder.finance.amountServices
          ? parseFloat(this.deliveryOrder.finance.amountServices)
          : 0
        let vat = this.deliveryOrder.tax
        if (!vat) {
          vat = 0
        }
        amountTtc = (amountReal - amountServices) * (1 + Number(this.deliveryOrder.tax) / 100) + amountServices
        amountTtc = amountTtc.toFixed(2)
      }
      return amountTtc
    },
    globalBuild(data) {
      this.def = data.def
      this.deliveryOrder = data.object
      if (Object.keys(data.object).length !== 0) {
        this.deliveryOrder.finance.amountReal = this.deliveryOrder.finance.amountReal
          ? parseFloat(this.deliveryOrder.finance.amountReal).toFixed(2)
          : parseFloat(this.deliveryOrder.finance.amount).toFixed(2)

        this.deliveryOrder.supplierId = this.deliveryOrder.finance.equipment.supplier.id
      }
      this.loading = data.loading
      this.loadField = data.build
    },
    isSending(bool) {
      this.sending = bool
    },
    setDatas(deliveryOrder) {
      this.deliveryOrder = deliveryOrder
      if (deliveryOrder.documentAssoc != null || (deliveryOrder.status === 'SIGNED' && !deliveryOrder.esign)) {
        location.reload()
      }
      this.deliveryOrderId = deliveryOrder.id
    },
    changeAmountReal(val) {
      this.deliveryOrder.finance.amountReal = val
      this.computeTtc()
    },
    changeAmountServices(val) {
      this.deliveryOrder.finance.amountServices = val
      this.computeTtc()
    },
    send() {
      this.sending = true
      this.$refs['formdeliverysingle'].datas['contractId'] = this.contractId
      if (!conf.signDelivery) {
        this.$refs['formdeliverysingle'].datas['esign'] = true
      }
      this.$refs['formdeliverysingle'].datas['single'] = true
      this.$refs['formdeliverysingle'].methods('post')
    },
    modify() {
      this.sending = true
      this.$refs['formdeliverysingle'].datas['contractId'] = this.contractId
      if (!conf.signDelivery) {
        this.$refs['formdeliverysingle'].datas['esign'] = true
      }
      this.$refs['formdeliverysingle'].datas['single'] = true
      this.$refs['formdeliverysingle'].methods('patch')
    },
    deleteDelivery(id) {
      let url = 'deliveryorder/' + id

      this.deleteJSON(this.freeUrl(url), { contractId: this.contractId }, {}).then((json) => {
        location.reload()
      })
    },
  },
  setup() {
    const deliveryOrder = ref(null)
    const { mandatory } = useDeliveredAtField(deliveryOrder)

    return { deliveryOrder, deliveredAtMandatory: mandatory }
  },
  beforeMount() {
    this.params = this.deliveryOrderId ? { deliveryOrderId: this.deliveryOrderId } : { contractId: this.contractId }
  },
  watch: {
    deliveredAtMandatory(required) {
      this.def.deliveredAt.options.required = required
    },
  },
}
</script>
<template>
  <div id="delivery-single" class="card">
    <ModalConfirmation
      id="modal-deliveredAt"
      ref="modalDeliveredAt"
      class-modal-dialog="modal-lg"
      message="delivery.deliveredAtConfirmation"
      button-confirm-title="main.bool.yes"
      button-cancel-title="main.bool.no"
      @confirm="closeDeliveredAtModal"
      @cancel="resetDeliveredAt"
    />
    <BlockContent>
      <h4 v-html="$t('delivery.message')"></h4>
      <FormCreator
        @update-data="updateData"
        ref="formdeliverysingle"
        src-error="formdeliverysingle"
        endpoint="v2/deliveryorder"
        :id="deliveryOrderId"
        :uuid="uuid"
        :params="params"
        class-to-add="d-none"
        @global-build="globalBuild"
        @form-return="setDatas"
        @is-sending="isSending"
      />
      <div v-if="!loading && deliveryOrder !== null">
        <div class="row">
          <div class="col-md-6">
            <FieldCreator
              :form-data="formData"
              v-if="loadField"
              name="finance.equipment.brand"
              form-ref="formdeliverysingle"
              domain="delivery"
              label-top
            />
          </div>
          <div class="col-md-6">
            <FieldCreator
              :form-data="formData"
              v-if="loadField"
              name="finance.amountReal"
              form-ref="formdeliverysingle"
              domain="delivery"
              label-top
              @get-input-change="changeAmountReal"
            />
          </div>
        </div>
        <div class="row">
          <div class="col-md-6">
            <FieldCreator
              :form-data="formData"
              v-if="loadField"
              name="finance.equipment.model"
              form-ref="formdeliverysingle"
              domain="delivery"
              label-top
            />
          </div>
          <div class="col-md-6">
            <FieldCreator
              :form-data="formData"
              v-if="loadField && conf.theme_dir == 'lbp'"
              name="finance.amountServices"
              form-ref="formdeliverysingle"
              domain="delivery"
              label-top
              @get-input-change="changeAmountServices"
            />
          </div>
        </div>
        <div class="row">
          <div class="col-md-6">
            <FieldCreator
              :form-data="formData"
              v-if="loadField"
              name="finance.equipment.serialNumber"
              form-ref="formdeliverysingle"
              domain="delivery"
              label-top
            />
          </div>
          <div class="col-md-6">
            <div class="my-2">
              <label class="fs-16 form-label-font require">{{ $t('delivery.fields.amountTtc.label') }}</label>
              <div class="input-group">
                <input
                  step="any"
                  pattern="^d*(.d{0,2}|,d{0,2})?$"
                  decoration="fa fa-euro"
                  type="number"
                  disabled="disabled"
                  class="form-control"
                  :value="computeTtc()"
                  e2e-input="deliveryOrderAmount"
                />
                <div class="input-group-append">
                  <span id="basic-addon2"><i class="fa fa-euro"></i></span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-6">
            <FieldCreator
              v-if="loadField"
              :form-data="formData"
              name="finance.equipment.firstRegistrationAt"
              form-ref="formdeliverysingle"
              domain="delivery"
              label-top
            />
          </div>
        </div>
        <div class="row">
          <div class="col-md-6">
            <FieldCreator
              :form-data="formData"
              v-if="loadField"
              name="finance.equipment.plate"
              form-ref="formdeliverysingle"
              domain="delivery"
              label-top
            />
          </div>
          <div class="col-md-6">
            <FieldCreator
              :form-data="formData"
              v-if="loadField"
              name="finance.equipment.usage"
              form-ref="formdeliverysingle"
              domain="delivery"
              label-top
            />
          </div>
        </div>
        <div class="row">
          <div class="col-md-6">
            <DeliveryOrderAddressField :form="formData" :entity-id="deliveryOrder.clientId" label-top />
          </div>
          <div
            v-if="def && def.deliveryPlace && def.deliveryPlace.options && def.deliveryPlace.options.display"
            class="col-md-1 d-flex justify-content-center align-items-center"
          >
            <p class="font-weight-bold mx-3 my-3" style="font-size: 20px">ou</p>
          </div>
          <div class="col-md-5">
            <FieldCreator
              :form-data="formData"
              v-if="loadField"
              name="deliveryPlace"
              form-ref="formdeliverysingle"
              domain="delivery"
              label-top
            />
          </div>
        </div>
        <div class="row">
          <div class="col-md-6">
            <FieldCreator
              ref="deliveredAt"
              :form-data="formData"
              v-if="loadField"
              name="deliveredAt"
              form-ref="formdeliverysingle"
              domain="delivery"
              label-top
              @get-date-change="validateDeliveredAt"
            />
          </div>
        </div>
        <SignatureBlock
          :form-data="formData"
          :object="deliveryOrder"
          v-if="loadField"
          :contract-id="contractId"
          :client-id="deliveryOrder.clientId"
          form-ref="formdeliverysingle"
          :form-instance="$refs.formdeliverysingle"
          label-top
          two-cols
        />

        <div class="row">
          <div class="col-md-6">
            <FieldCreator
              :form-data="formData"
              v-if="loadField"
              name="operationalAt"
              form-ref="formdeliverysingle"
              domain="delivery"
              label-top
            />
          </div>
        </div>
        <div
          v-if="conf.signDelivery && deliveryOrder.signDeliveryOrder"
          class="my-4 py-3 col-11 mx-auto bg-info"
          style="border-radius: 1em"
        >
          <div class="text-center" e2e-data="deliveryOrderSignStatus">{{ $t('delivery.signStatus') }}</div>
          <div class="row d-flex justify-content-center text-center" style="margin: 1em auto">
            <FieldCreator
              :form-data="formData"
              v-if="loadField"
              name="esign"
              form-ref="formdeliverysingle"
              domain="delivery"
              @checked="deliveryOrder.esign = $event"
            />
          </div>
        </div>
        <div class="text-left mb-3 mt-40">
          <ButtonAll
            margin="no"
            v-if="showDeliveryUpdateButton"
            type="validation"
            icon="calendar"
            label="button.save"
            name="deliveryUpdate"
            :loading="sending"
            @click="modify"
          />
        </div>
        <div v-if="!user?.isReadOnly && deliveryOrder" class="text-center">
          <ButtonAll
            marge="no"
            v-if="deliveryOrderId === null"
            label="delivery.create"
            type="validation"
            :loading="sending"
            @click="send"
            name="deliveryOrderCreate"
          />
          <ButtonAll
            marge="no"
            v-if="editable"
            label="delivery.modifyViewSingle"
            type="validation"
            :loading="sending"
            @click="modify"
            name="deliveryOrderUpdate"
          />
          <ButtonAll
            margin="no"
            :label="deliveryOrder.leaseback ? 'delivery.leasebackCancel' : 'delivery.cancel'"
            v-if="cancelable"
            type="warning"
            @click="deleteDelivery(deliveryOrderId)"
            name="deliveryOrderDelete"
          />
        </div>
      </div>
      <div v-else>
        <div class="row justify-content-around">
          <div class="col-md-5">
            <div class="row py-3 mb-3 loading"></div>
          </div>
          <div class="col-md-5">
            <div class="row py-3 mb-3 loading"></div>
          </div>
        </div>
        <div class="row justify-content-around">
          <div class="col-md-5">
            <div class="row py-3 mb-3 loading"></div>
          </div>
          <div class="col-md-5">
            <div class="row py-3 mb-3 loading"></div>
          </div>
        </div>
      </div>
      <div v-if="deliveryOrder !== null" class="mt-3">
        <ContractDeliveryOrderSignature
          ref="deliverysign"
          :delivery="deliveryOrder"
          :uuid="uuid"
          :contract-number="contractNumber"
        />
      </div>
    </BlockContent>
  </div>
</template>
